export const languageEnum = {
    EN: "en",
    TW: "tw",
    CN: "cn",
    JP: "jp",
    DE: "de",
};

export const languageIdEnum = {
    EN: 1,
    TW: 2,
    CN: 3,
    JP: 4,
    DE: 8,
};

export const countryCodeEnum = {
    EN: "english",
    TW: "zh-tw",
    CN: "zh-cn",
    JP: "ja",
    DE: "german",
};

export const iso639LangCode = {
    EN: "en",
    TW: "zh-Hant-TW",
    CN: "zh-Hans-CN",
    JP: "ja",
    DE: "de",
}
